import { CropConstants } from './constants/Crop';

export const updatePhoneNumberBasedOnCountry = (phone: string | undefined, country: string) => {
  const cleanPhone = (phone ?? '').replace('+', '');
  if (country.toLowerCase().replace(/\s+/g, '') === CropConstants.SERBIA.toLowerCase()) {
    return `+${cleanPhone}`;
  } else {
    return cleanPhone;
  }
};
